import { cloneDeep, uniqueId } from 'lodash';
import { Editor, Element as SlateElement } from 'slate';

import { slateToText } from 'src/components/RichSlate';
import { getBadgeType } from 'src/data/generationTool';
import { SLATE_TEXT_FORMATS } from 'src/lib/slate';

const parseScore = (score) => {
  try {
    const parsed = parseInt(score, 10);
    return parsed || 0;
  } catch {
    return 0;
  }
};

export const collectDDVariationFromEditor = (editor) => {
  const version = uniqueId();

  const nodes = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n.type === SLATE_TEXT_FORMATS.DD_VARIATION,
    })
  );
  return nodes.reduce((acc, [node]) => {
    if (node.type === SLATE_TEXT_FORMATS.DD_VARIATION) {
      acc.push({
        ...node.variation,
        score: parseScore(node.variation.score),
        editorValue: cloneDeep(node.children),
        text: slateToText(node.children),
        version,
      });
    }
    return acc;
  }, []);
};

export const createBadgeTypeToolMapper = (newTools, improvedTools) => (item) => ({
  ...item,
  badgeType: getBadgeType(item.tool, newTools, improvedTools),
});
